import { render, staticRenderFns } from "./HotelAdd.vue?vue&type=template&id=23e933b4&"
import script from "./HotelAdd.vue?vue&type=script&lang=js&"
export * from "./HotelAdd.vue?vue&type=script&lang=js&"
import style0 from "./HotelAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports